import ApiClient from '../ApiClient';

const FeedbackService = {
  async submitFeedback(payload, businessAdminId) {
    const params = {};
    if (businessAdminId) {
      params.businessAdminId = businessAdminId;
    }
    const resp = await ApiClient.post('/feedback', payload, { params });
    return resp;
  },

  async checkAlreadySubmitted(eventId, email, businessAdminId) {
    const resp = await ApiClient.get('/feedback/check-submitted', {
      params: { eventId, email, businessAdminId },
    });
    return resp;
  },

  async fetchEventFeedbackSummary(eventId) {
    const resp = await ApiClient.get(`/feedback/event/${eventId}/summary`);
    return resp;
  },
};

export default FeedbackService;
